import "./createEvent.css";
import React, { useState } from "react";
import { IoClose, IoAdd } from "react-icons/io5";
import {
	EditIconUpdated,
	UsersIconUpdated,
	TimeIconUpdated,
	RepeatIconUpdated,
	// video,
	MenuIconUpdated,
} from "../../../assets";
import { createEventModel } from "../../../models/createEvent.model";
import { SlEvent } from "react-icons/sl";
import { useAppContext } from "../../../context/AppContext";
import { LightLoader } from "../../../components";
import EmailInput from "../../Email/EmailInput";
import axiosInstance from "../../../services/api.service";
import secureLocalStorage from "react-secure-storage";

function CreateEvent({ title, onClose, handleShowSuccessModal }) {
	const eventType = secureLocalStorage.getItem("eventMode");

	const { getAllEvents, setLoadingAllEvents, showToastError, desktopView } =
		useAppContext();
	const [newEvent, setNewEvent] = useState(createEventModel);
	const [emails, setEmails] = useState([]);
	const [loading, setLoading] = useState(false);

	const [eventMode, setEventMode] = useState(eventType || "internal");

	const [allDay, setAllDay] = useState(false);
	const [repeat, setRepeat] = useState(false);

	const handleAllDaySwitch = () => {
		setAllDay(!allDay);
	};

	const handleRepeatSwitch = () => {
		setRepeat(!repeat);
	};

	const handleEventModeChange = (e) => {
		setEventMode(e.target.value);
	};

	// Handle form change:
	const handleFormChange = (e) => {
		setNewEvent({
			...newEvent,
			[e.target.name]: e.target.value,
		});
	};

	// Handle Submit | Create new event:
	const handleCreateNewEvent = async (e) => {
		e.preventDefault();
		setLoading(true);

		const newEventFormatter = {
			...newEvent,
			participants: desktopView
				? emails
				: newEvent.participants.split(",").map((email) => {
						if (email.trim() && email.includes("@")) {
							return email.trim();
						} else {
							return email.trim().concat("@cardinalstone.com");
						}
					}),
			eventMode: eventMode,
			allDay: allDay,
			recurring: repeat,
		};

		try {
			const res = await axiosInstance.post("/api/v1/event", newEventFormatter);

			if (res.status === 201) {
				getAllEvents();
				handleShowSuccessModal();
				setNewEvent(createEventModel);
			}
		} catch (error) {
			const errMsg = error?.response?.data?.message;
			showToastError(errMsg);
		}
		setLoading(false);
		setLoadingAllEvents(false);
	};

	return (
		<>
			<div className="create_event_container">
				<div className="create_modal_event_header">
					<h1>{title}</h1>
					<IoClose
						className="create_modal_event_close_icon"
						onClick={onClose}
					/>
				</div>

				<form
					className="create_modal_event_body"
					onSubmit={handleCreateNewEvent}
				>
					<div className="create_modal_title">
						<img src={EditIconUpdated} alt="Edit Icon" />
						<input
							className="form_input create"
							type="text"
							placeholder="Title"
							name="title"
							value={newEvent.title}
							onChange={handleFormChange}
							required
						/>
					</div>

					<div className="create_modal_users">
						<img src={UsersIconUpdated} alt="Users Icon" />
						{desktopView ? (
							<EmailInput emails={emails} setEmails={setEmails} />
						) : (
							<input
								className="form_input create"
								type="text"
								placeholder="Add participants"
								name="participants"
								value={newEvent.participants}
								onChange={handleFormChange}
								required
							/>
						)}
					</div>

					<div className="create_modal_events">
						<SlEvent className="SlEvent create" />
						<div className="create_modal_event_inner">
							<p>Event</p>
							<div className="radio_groups_wrapper">
								<div className="radio_group">
									<input
										type="radio"
										id="internal"
										name="eventMode"
										value="internal"
										checked={eventMode === "internal"}
										onChange={handleEventModeChange}
									/>
									<label htmlFor="internal">Internal</label>
								</div>
								<div className="radio_group">
									<input
										type="radio"
										id="external"
										name="eventMode"
										value="external"
										checked={eventMode === "external"}
										onChange={handleEventModeChange}
									/>
									<label htmlFor="external">External</label>
								</div>
							</div>
						</div>
					</div>

					<div className="create_modal_time">
						<img src={TimeIconUpdated} alt="Time Icon" />
						<div className="create_modal_time_inner">
							<div className="create_modal_time_inner_start_time">
								<p>All Day</p>
								<div
									className={`all_day_switch_container ${allDay}`}
									onClick={handleAllDaySwitch}
								>
									<span className={`all_day_switch ${allDay}`}></span>
								</div>
							</div>
							<div className="create_modal_time_inner_start_time">
								<p>Start time</p>
								<input
									type="datetime-local"
									className="form_input time_create"
									name="startTime"
									value={newEvent.startTime}
									onChange={handleFormChange}
									required
								/>
							</div>
							<div className="create_modal_time_inner_end_time">
								<p>End time</p>
								<input
									type="datetime-local"
									className="form_input time_create"
									name="endTime"
									value={newEvent.endTime}
									onChange={handleFormChange}
									required
								/>
							</div>
						</div>
					</div>

					<div className="create_modal_repeat">
						<img src={RepeatIconUpdated} alt="Repeat Icon" />
						<div className="create_modal_repeat_inner">
							<p>Repeat</p>
							<div
								className={`repeat_switch_container ${repeat}`}
								onClick={handleRepeatSwitch}
							>
								<span className={`repeat_switch ${repeat}`}></span>
							</div>
						</div>
					</div>

					{/* <div className="create_modal_meetingLink">
						<input
							className="form_input create"
							type="url"
							placeholder="Teams Meeting Link"
							name="meetingLink"
							value={newEvent.meetingLink}
							onChange={handleFormChange}
							required
						/>
						<img src={video} alt="Video Icon" />
					</div> */}

					<div className="create_modal_menu create">
						<img src={MenuIconUpdated} alt="Menu Icon" />
						<div className="create_modal_menu_inner">
							<textarea
								type="text"
								className="form_textarea create"
								placeholder="Other details"
								name="otherDetails"
								value={newEvent.otherDetails}
								onChange={handleFormChange}
							/>
						</div>
					</div>

					<div className="create_modal_button">
						{loading ? (
							<button className="create_modal_new_event_button">
								<LightLoader />
							</button>
						) : (
							<button className="create_modal_new_event_button">
								<IoAdd className="create_modal_new_event_icon" />
								Create Event
							</button>
						)}
					</div>
				</form>
			</div>
		</>
	);
}

export default CreateEvent;
